import PropTypes from 'prop-types'
// import MobileBillPayLayout from './MobileBillPayLayout'
// import { isTuxApp } from '../../utils/browserutils'

const AppLayout = ({ children }) => (
  <>
    {/* {isTuxApp() ? (
      <MobileBillPayLayout>{children}</MobileBillPayLayout>
    ) : ( */}
    {children}
    {/* )} */}
  </>
)

AppLayout.propTypes = {
  children: PropTypes.element.isRequired
}

export default AppLayout
